import { isEqual } from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { getClass } from '../../../utils/component-helpers';

import './publisher-dropdown.scss';

class PublisherDropdown extends Component {
	constructor(props) {
		super(props);

		const selectedPublisher = this.props.publisherDisplayed ?
			this.props.publisherDisplayed.full_name : 'Select Publisher';
		this.state = {
			publishers: this.props.publishers,
			publisherList: this.props.publishers,
			opened: false,
			selectedPublisher: selectedPublisher,
			searchTerm: '',
		};

		this.dropdownDiv = null;
	}

	componentDidUpdate(prevProps) {
		if (!isEqual(prevProps.publishers, this.props.publishers)) {
			this.setState({
				publishers: this.props.publishers,
				publisherList: this.props.publishers,
			});
		}
		// Allow updating publisher label from parent component
		if (this.props.publisherDisplayed &&
			!isEqual(prevProps.publisherDisplayed, this.props.publisherDisplayed)) {
			this.setState({
				selectedPublisher: this.props.publisherDisplayed.full_name,
			});
		}
	}

	componentDidMount() {
		window.addEventListener('click', (event) => this.handleClickOutside(event));
	}

	componentWillUnmount() {
		window.removeEventListener('click', (event) => this.handleClickOutside(event));
	}

	handleClickOutside(event) {
		if (!this.dropdownDiv || !this.state.opened ||
			this.dropdownDiv.contains(event.target)) return;

		this.toggleDropdown();
	}

	toggleDropdown() {
		// Prevent user from opening dropdown if no publishers are present
		if (!this.state.publishers.length) return;
		this.setState({opened: !this.state.opened});
	}

	filterPublishersByName(searchTerm) {
		const publishers = this.state.publishers.filter((publishers) => {
			const name = publishers.full_name || '';
			return name.toLowerCase().startsWith(searchTerm.toLowerCase());
		});

		this.setState({
			publisherList: publishers,
			searchTerm: searchTerm,
		});
	}

	handleSearchChange(event) {
		this.filterPublishersByName(event.target.value);
	}

	selectPublisher(publisher) {
		this.props.selectPublisher(publisher, this.props.showOverride);
		this.setState({
			opened: false,
			selectedPublisher: publisher.full_name,
		});
	}

	render() {
		const publishers = this.state.publisherList.map((publisher) => {
			return (
				<div
					key={publisher.slug}
					className="publisher-label-container">
					<div
						className="publisher-label"
						onClick={() => this.selectPublisher(publisher)}>
						{publisher.full_name}
					</div>
				</div>
			);
		});
		return (
			<>
				<div
					ref={(node) => this.dropdownDiv = node}
					className="publisher-dropdown">
					<span className="dropdown-header">Publisher</span>
					<div
						className="dropdown-toggle"
						onClick={() => this.toggleDropdown()}>
						{this.state.selectedPublisher}
						<span className={this.state.opened ? 'arrow-up' : 'arrow-down'}></span>
					</div>
					<div className={getClass('dropdown-menu', {
						'show': this.state.opened,
					})}>
						<div className="search-input">
							<span className="narrativ-icon search"></span>
							<input
								type="text"
								placeholder="Search"
								value={this.state.searchTerm}
								onChange={this.handleSearchChange.bind(this)}
							/>
						</div>
						{publishers}
					</div>
				</div>

			</>
		);
	}
}

export default withRouter(PublisherDropdown);
